module.exports = __webpack_public_path__ + "img/f4-3-2.c46128b8.png";